import api from "@/services/api"
import { Noticeboard, Note, NoteWithUser } from "@/types/noticeboard"

class ApiNoticeboard {
	private get axios () { return api.getAxios() }

	public async noticeboardList (): Promise<Noticeboard[]> {
		const result = await this.axios.get("/noticeboards")
		return result.data
	}

	public async noticeboardSave (noticeboard: Noticeboard): Promise<string> {
		return (await this.axios.post("/noticeboards", noticeboard)).data
	}

	public async noticeboardDelete (noticeboardId: string): Promise<void> {
		await this.axios.delete(`/noticeboards/${noticeboardId}`)
	}

	public async noteList (noticeboardId: string): Promise<NoteWithUser[]> {
		const result = await this.axios.get(`/noticeboards/${noticeboardId}/notes`)
		return result.data
	}

	public async noteSave (note: Note): Promise<string> {
		const result = (await this.axios.post("/noticeboards/notes", note))
		return result.data
	}

	public async noteDelete (noteId: string): Promise<void> {
		await this.axios.delete(`/noticeboards/notes/${noteId}`)
	}
}

const apiNoticeboard = new ApiNoticeboard()
export default apiNoticeboard
